import styled, { css } from 'styled-components';

import { colorSchema, media, textSizes } from 'utils/style';
import LoadSpinner from 'components/LoadSpinner/component';

const LoadSpinnerTheme = {
  skins: {
    standar: {
      textColor: colorSchema('grey700'),
      loaderColor: colorSchema('greyMouse'),
      size: '6',
      position: {
        margin: '0 auto',
        marginWrap: '0 9px',
        loaderMargin: '0 auto',
        loaderMarginMobile: '0 0 0 33px',
        justify: 'space-between',
        minHeightL: '55px',
        minHeightM: '32px',
      },
    },
    center: {
      textColor: colorSchema('grey700'),
      loaderColor: colorSchema('grey700'),
      size: 6,
      position: {
        margin: '0 auto',
        marginWrap: '0',
        loaderMargin: '0 auto',
        loaderMarginMobile: '0 auto',
        justify: 'center',
        minHeightL: '55px',
        minHeightM: '32px',
      },
    },
    inButton: {
      textColor: colorSchema('white'),
      loaderColor: colorSchema('white'),
      size: '6',
      position: {
        margin: '0 auto',
        marginWrap: '0 auto',
        loaderMargin: '0 auto',
        loaderMarginMobile: '0 auto',
        justify: 'center',
        minHeightL: '23px',
        minHeightM: '23px',
      },
    },
    inButtonGrey: {
      textColor: colorSchema('grey700'),
      loaderColor: colorSchema('greyMouse'),
      size: '4',
      position: {
        margin: '0 auto',
        marginWrap: '0 auto',
        loaderMargin: '0 auto',
        loaderMarginMobile: '0 auto',
        justify: 'center',
        minHeightL: '23px',
        minHeightM: '23px',
      },
    },
    inButtonSmall: {
      textColor: colorSchema('white'),
      loaderColor: colorSchema('white'),
      size: '3',
      position: {
        margin: '0 auto',
        marginWrap: '0',
        loaderMargin: '0 auto',
        loaderMarginMobile: '0 auto',
        justify: 'center',
        minHeightL: '16px',
        minHeightM: '16px',
      },
    },
  },
};

const skinsProps = ({ skin, size }) => {
  const schema = LoadSpinnerTheme.skins[skin] || LoadSpinnerTheme.skins.standar;

  return css`
    color: ${schema.textColor};
    margin: ${schema.position.margin};
    .loadWrap {
      justify-content: ${schema.position.justify};
      min-height: ${schema.position.minHeightM};
      margin: ${schema.position.marginWrap};
      ${media.lessThan('medium')`
        min-height: ${schema.position.minHeightL};
      `}
      ${media.lessThan('extraSmall')`
        min-height: ${schema.position.minHeightM};
      `}
    }
    .loader,
    .loader:before,
    .loader:after {
      background: ${schema.loaderColor};
      margin: ${schema.position.loaderMargin};
    }
    .loader {
      font-size: ${size || schema.size}px;
      color: ${schema.loaderColor};
      ${media.lessThan('extraSmall')`;
        margin: ${schema.position.loaderMarginMobile};
      `}
    }
  `;
};

export default styled(LoadSpinner)`
  ${skinsProps}
  display: flex;
  width: 100%;
  height: 100%;
  ${media.lessThan('medium')`
    margin: 0;
    justify-content: flex-start;
  `};
  ${media.lessThan('extraSmall')`
    padding-top: 0;
  `}

  .loadWrap {
    display: flex;
    flex-direction: row;
    align-items: center;
    height: 100%;
    width: 100%;
    ${media.lessThan('medium')`
      flex-direction: column-reverse;
      width: auto;
      justify-content: center;
      align-items: center;
      width: 100%;
      padding-top: 6px;
    `}
    ${media.lessThan('extraSmall')`
      justify-content: center;
    `}
  }
  .loadText {
    :first-letter {
      text-transform: capitalize;
    }
    margin: 0 0 0 -9px;
    font-size: ${textSizes('M')};
    flex: 1;
    ${media.lessThan('medium')`
      margin: 0;
      flex: 0;
    `}
    ${media.lessThan('extraSmall')`
      display: none;
    `}
  }
  .loader,
  .loader:before,
  .loader:after {
    -webkit-animation: load1 1s infinite ease-in-out;
    animation: load1 1s infinite ease-in-out;
    width: 1em;
    height: 4em;
  }
  .loader {
    text-indent: -9999em;
    position: relative;
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation-delay: -0.16s;
    animation-delay: -0.16s;
  }
  .loader:before,
  .loader:after {
    position: absolute;
    top: 0;
    content: '';
  }
  .loader:before {
    left: -1.5em;
    -webkit-animation-delay: -0.32s;
    animation-delay: -0.32s;
  }
  .loader:after {
    left: 1.5em;
  }
  @-webkit-keyframes load1 {
    0%,
    80%,
    100% {
      box-shadow: 0 0;
      height: 3em;
    }
    40% {
      box-shadow: 0 -1em;
      height: 3.5em;
    }
  }
  @keyframes load1 {
    0%,
    80%,
    100% {
      box-shadow: 0 0;
      height: 3em;
    }
    40% {
      box-shadow: 0 -1em;
      height: 3.5em;
    }
  }
`;
